module.exports = __webpack_public_path__ + "static/media/loyaltyTierSilverBackground.32c64691.png";